import { TRITECNICA_COLORS } from '../tritecnicaThemeConf';
export const tritecnicaSentryReportStyle = {
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]': {
        backgroundColor: `${TRITECNICA_COLORS.success.main} !important`,
        border: 'none !important',
        outline: 'none !important',
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:hover': {
        backgroundColor: `${TRITECNICA_COLORS.success.dark} !important`,
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:active': {
        backgroundColor: `${TRITECNICA_COLORS.success.main} !important`,
    },
};
//# sourceMappingURL=tritecnicaSentryReportStyle.js.map